import { render } from "./AmbaInput.vue?vue&type=template&id=9a43f008&scoped=true"
import script from "./AmbaInput.vue?vue&type=script&lang=ts"
export * from "./AmbaInput.vue?vue&type=script&lang=ts"

import "./AmbaInput.vue?vue&type=style&index=0&id=9a43f008&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-9a43f008"

export default script